import React from 'react'
import { NavLink } from 'react-router-dom'
import Divider from '../Divider'

import './style.css'
import { useTranslation } from 'react-i18next'

export const FooterAsbo = ({ style }) => {
  const { t } = useTranslation()
  return (
    <section className={'footer'} style={{ ...style, background: '#EEF2F6' }}>
      <div className='container'>
        <div className='row'>
          <NavLink to='/'>
            <img src='/images/logo-asbo-footer.png' width={185} alt='' />
          </NavLink>
        </div>
        <div className='row pt100'>
          <a
            target='_blank'
            className='footer-link-item'
            href='https://www.ajg.com/uk/global-privacy-notice/'
            rel='noreferrer'
          >
            {t('Privacy policy')}
          </a>
          <a
            target='_blank'
            className='footer-link-item'
            href='https://www.ajg.com/uk/legal-and-regulatory-information/'
            rel='noreferrer'
          >
            Legal & Regulatory Information
          </a>
          <a
            target='_blank'
            className='footer-link-item'
            href='https://www.ajg.com/uk/about-us/modern-slavery/'
            rel='noreferrer'
          >
            Modern Slavery Statement
          </a>
        </div>

        <Divider style={{ background: '#1D1D294D' }} />
        <div className='column'>
          <p className='copyright-text'>Copyright © 2026 Cyber Defence Centre. All Rights reserved</p>
          <br />
          <p className='copyright-text'>
            The Cyber Risk Management Service is a non-insurance risk management service. It is not regulated as an
            insurance product under US law. Services are provided by the UK-based Cyber Risk Team of Arthur J. Gallagher
            Insurance Brokers Limited, which is authorised and regulated by the UK Financial Conduct Authority. This
            service does not replace the need for appropriate insurance coverage or legal advice.
          </p>
        </div>
        <div id='bottom-page' className='row'></div>
      </div>
    </section>
  )
}
